/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidvalue1Inputs */

const en_invalidvalue1 = /** @type {(inputs: Invalidvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid value`)
};

const de_invalidvalue1 = /** @type {(inputs: Invalidvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger Wert`)
};

/**
* | output |
* | --- |
* | "Invalid value" |
*
* @param {Invalidvalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidvalue1 = /** @type {((inputs?: Invalidvalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidvalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidvalue1(inputs)
	return de_invalidvalue1(inputs)
});
export { invalidvalue1 as "invalidValue" }